const STORAGE_KEY = 'insightsPreferences'
export const INSIGHTS_PREFERENCES_EVENT = 'insightsPreferencesChange'

export interface InsightsPreferences {
  enabled: boolean
  autoOpen: boolean
  showAiChats: boolean
  showDashboards: boolean
  showHealth: boolean
  hideOrgLogos: boolean
}

const DEFAULTS: InsightsPreferences = {
  enabled: false,
  autoOpen: true,
  showAiChats: false,
  showDashboards: false,
  showHealth: false,
  hideOrgLogos: false
}

function read(): InsightsPreferences {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return DEFAULTS
    }
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return DEFAULTS
    }
    // Every preference is a boolean; keep the stored value when valid, else default
    const result = { ...DEFAULTS }
    for (const key of Object.keys(DEFAULTS) as (keyof InsightsPreferences)[]) {
      if (typeof parsed[key] === 'boolean') {
        result[key] = parsed[key]
      }
    }
    return result
  } catch (e) {
    console.error('[insightsPreferencesStorage] Failed to read', e)
    return DEFAULTS
  }
}

function write(prefs: InsightsPreferences): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs))
    window.dispatchEvent(new Event(INSIGHTS_PREFERENCES_EVENT))
  } catch (e) {
    console.error('[insightsPreferencesStorage] Failed to write', e)
  }
}

export const insightsPreferencesStorage = {
  get(): InsightsPreferences {
    return read()
  },

  set(next: Partial<InsightsPreferences>): void {
    write({ ...read(), ...next })
  }
}
